import { getInnerApiProxyData } from '@remote/api/proxy'

/**
 * 获取历史下载路径记录
 */
export const fetchHistoryDownloadPath = () => {
  return getInnerApiProxyData({
    proxyUrl: 'device/download_paths', 
    proxyMethod: 'GET',
  }) as unknown as Promise<API_DEVICE.HistoryDownloadPath[]>
}

/**
 * 创建历史下载路径记录
 * @param fileID 下载目录的fileID
 */
export const createHistoryDownloadPath = (fileID: string) => {
  return getInnerApiProxyData({
    proxyUrl: 'device/download_path', 
    proxyMethod: 'POST',
    proxyData: {
      file_id: fileID,
    },
  }) as Promise<{}>
}


/**
 * 删除历史下载路径记录
 * @param id 历史路径记录的id
 */
export const deleteHistoryDownloadPath = (id: string) => {
  return getInnerApiProxyData({
    proxyUrl: `device/download_path/${id}`,
    proxyMethod: 'DELETE',
  }) as Promise<{}>
}